import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import cuideoTheme from "../../../../containers/themes/defaultTheme";
import ErrorOutlineOutlinedIcon from "@material-ui/icons/ErrorOutlineOutlined";
import { FormattedMessage } from "react-intl";
import ErrorList from "./ErrorList";

const StyledDialog = styled(Dialog)`
  .MuiDialog-paper {
    background-color: ${cuideoTheme.palette.error.dark};
    color: ${cuideoTheme.palette.error.contrastText};

    .MuiButtonBase-root {
      color: ${cuideoTheme.palette.error.contrastText};
      border-color: ${cuideoTheme.palette.error.contrastText};
    }
  }
`;

const StyledContent = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: flex-start;

  .MuiSvgIcon-root {
    margin-top: 0.5rem;
    width: 2rem;
    height: 2rem;
  }
`;

const StyledErrorValidatingText = styled(Typography)`
  font-size: 1rem;
  font-weight: 600;
  margin-left: 1rem;
`;

export type TValidationError = {
  type: "validation_error";
  field: string;
  message: string;
};

interface ValidationErrorsDialogProps {
  open: boolean;
  errors: TValidationError[];
  onAccept: () => void;
}

const ValidationErrorsDialog = (props: ValidationErrorsDialogProps) => {
  const { open, errors, onAccept } = props;
  const [storedErrors, setStoredErrors] = useState(errors);

  useEffect(() => {
    if (errors.length > 0) {
      setStoredErrors(errors);
    }
  }, [errors]);

  return (
    <StyledDialog open={open}>
      <DialogContent>
        <StyledContent>
          <ErrorOutlineOutlinedIcon />
          <Box>
            <StyledErrorValidatingText>
              <FormattedMessage
                id="ValidationErrorsDialog.Hay errores que no permiten la validación del servicio. Por favor, revísalos"
                defaultMessage="Hay errores que no permiten la validación del servicio. Por favor, revísalos"
              />
            </StyledErrorValidatingText>
            <ErrorList errors={storedErrors} />
          </Box>
        </StyledContent>
      </DialogContent>
      <DialogActions>
        <Button color="primary" variant="outlined" onClick={onAccept}>
          <FormattedMessage
            id="ValidationErrorsDialog.Accept"
            defaultMessage="Aceptar"
          />
        </Button>
      </DialogActions>
    </StyledDialog>
  );
};

export default ValidationErrorsDialog;
